import { FC } from "react";

export interface QuickFiltersItem {
  label: string,
  onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => unknown,
  active?: boolean,
}

export interface IQuickFilters {
  options?: QuickFiltersItem[],
}

const QuickFilters: FC<IQuickFilters> = ({ options }) => (
  <div className="flex flex-wrap gap-2 text-xs items-center ">
    {!!options?.length && options.map(({ label, onClick, active }, i) => (
      <div
        key={`${label}_${i}`}
        role="button"
        tabIndex={-1}
        className={`
          flex items-center border-[1px] rounded-xl py-1.5 px-2
          hover:shadow-md transition-all
          ${active 
            ? 'border-primary bg-primary text-white' 
            : 'text-text border-border_color hover:text-black hover:border-black'
          }
        `}
        onClick={(e) => onClick && onClick(e)}
      >
        {label}
      </div>
    ))}
  </div>
);

export default QuickFilters;
